/**
 * @module support/ingenico
 * @copyright 1994-2017 T-Mobile US, Inc. All Rights Reserved.
 */ /** */

import { Injectable } from '@angular/core';
import { of as observableOf, Observable } from 'rxjs';

/**
 * Void Ingenico Service
 * @access public
 */
@Injectable()
export class VoidIngenicoService {
  constructor() {}

  /**
   * Display terms and conditions on ingenico screen
   * @param {string} langPref
   * @param {string} textString
   */
  public acceptTermsAndConditionsForm(langPref: string, textString: string): Observable<string> {
    return observableOf(null);
  }

  public displayThankYou(): void {}

  public displayAds(): void {}
}
